module.exports = __webpack_public_path__ + "media/images/icon-haccps-check-disabled-29f96f6df6f816e778a75222a8a5c6bc.svg";